const footer = "_uxsf14s2m37";
const relief = "_uxsr1ghf7yu";
const content = "_uxsc1mpn4pw";
const copyright = "_uxsc10j4p3v";
const pageContext = "_uxsp9gg4x5";
const pageNumber = "_uxspoimo8z";
const publisherLogo = "_uxsprk8h09";

export { content, copyright, footer, pageContext, pageNumber, publisherLogo, relief };
import "./footer.style.linaria.module.css";
//# sourceMappingURL=footer.style.js.map
